import React from 'react';
import { VisitorLocatorServiceV1 } from '@volkswagen-onehub/audi-feature-service-visitor-locator';

type VisitorLocatorServiceState = {
  visitorLocatorService: VisitorLocatorServiceV1 | null;
};

export type State = {
  visitorLocatorService: VisitorLocatorServiceV1 | null;
};

export const defaultState: VisitorLocatorServiceState = {
  visitorLocatorService: null,
};

export const visitorLocatorServiceStateContext = React.createContext<State | null>(null);

const Provider = ({
  children,
  visitorLocatorService,
}: {
  children: React.ReactNode;
  visitorLocatorService?: VisitorLocatorServiceV1;
}) => {
  const [state] = React.useState({
    ...defaultState,
    visitorLocatorService: visitorLocatorService || null,
  });

  return (
    <visitorLocatorServiceStateContext.Provider value={state}>
      {children}
    </visitorLocatorServiceStateContext.Provider>
  );
};

function useVisitorLocatorServiceState() {
  const context = React.useContext(visitorLocatorServiceStateContext);
  if (!context) {
    throw new Error('useVisitorLocatorServiceState must be used within a Provider');
  }
  return context;
}

export default { Provider, useVisitorLocatorServiceState };
